module.exports = "/_next/static/images/home-duotone-457835486515b4b47c31c8070df69c8d.svg";